import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-mb-switch',
  templateUrl: './mb-switch.component.html',
  styleUrls: ['./mb-switch.component.css'],
})
export class MbSwitchComponent {
  @Input() checked = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  onToggle(event: Event) {
    const input = event.target as HTMLInputElement;
    this.checkedChange.emit(input.checked);
  }
}
